import * as React from "react";
import { Modal, Form, Button } from "semantic-ui-react";

interface Props {
    onClose: () => void;
}

const ImmunisationWarningModal: React.FunctionComponent<Props> = (props) => {
    return (
        <Modal open>
            <Modal.Content>
                <Form>
                    <span>No documented consent to release COVID-19 Vaccination status to employer on either PPQ or Immunisation Review,
                        please check for documented consent in other tasks before releasing information</span>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={props.onClose}>Close</Button>
            </Modal.Actions>
        </Modal>
    );
};

export { ImmunisationWarningModal };
